<script lang="ts">
  import TeamComponent from "$components/team/index.svelte";
  import type { PageData } from "./$types";
  import type { ITeamEvent } from "./+page.server";
  import type { ITicketSchema } from "$lib/utils/ldjson.js";
  import { serializeSchema, ticketToSchema } from "$lib/utils/ldjson.js";
  import MetaComponent from "$components/meta/index.svelte";

  export let data: PageData;
  const { meta = [] } = data?.results;

  function toSchema(card: ITeamEvent) {
    const { product } = card;

    const row: ITicketSchema = {
      title: card.title,
      datetime: card.datetime,
      tbc: card.tbc,
      slug: `${card.subcategory.slug}${card.slug}`,
      subcategory: {
        title: card.subcategory.title,
        slug: card.subcategory.slug,
      },
      performers: card.performers,
      venue: card?.venue,
      qty: card?.product?.qty,
      priceFrom: product
        ? {
            proceedPrice: product.offerPrice || product.proceedPrice || 0,
            currency: product.currency as string,
          }
        : undefined,
    };

    return serializeSchema(ticketToSchema(row));
  }
</script>

<MetaComponent {meta} />

<svelte:head>
  {#each data.results.events || [] as row}
    {@html toSchema(row)}
  {/each}
</svelte:head>

<TeamComponent {data} />
